import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import moment from 'moment'
import * as api from './api'
// import * as tz from 'moment-timezone'
import i18n from '../public/i18n/i18n'

Vue.config.productionTip = false

Vue.prototype.$_AXIOS = axios
Vue.prototype.$_MOMENT = moment
Vue.prototype.$_API = api
// Vue.prototype.$_TZ = tz

// if (process.env.NODE_ENV === 'development') {
//   console.log('DEV_MODE')
//   require('./mock')
// }

new Vue({
  i18n,
  render: h => h(App)
}).$mount('#app')
